export enum OrganizationType {
  Dental = 1,
  SkinCare = 2,
  BeautyParlor = 3,
}

export interface OrganizationResponse {
  id: string;
  name: string;
  slug: string;
  organizationType?: OrganizationType;
  phone: string;
  email: string;
  description?: string;
  address: string;
  city: string;
  area: string;
  latitude?: number | null;
  longitude?: number | null;
  googleMapsUrl?: string;
  logoUrl?: string;
  bannerUrl?: string;
  facebookUrl?: string | null;
  twitterUrl?: string | null;
  linkedInUrl?: string | null;
  instagramUrl?: string | null;
  youtubeUrl?: string | null;
  tiktokUrl?: string | null;
  websiteTitle?: string;
  websiteTagline?: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  createdBy?: string | null;
  updatedBy?: string | null;
}

export interface OrganizationListResult {
  items: OrganizationResponse[];
  totalCount: number;
  page: number;
  pageSize: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
}

export interface CreateOrganizationRequest {
  name: string;
  slug: string;
  organizationType: OrganizationType;
  phone?: string;
  email?: string;
  description?: string;
  address?: string;
  city?: string;
  area?: string;
  latitude?: number;
  longitude?: number;
  googleMapsUrl?: string;
  isActive: boolean;
  facebookUrl?: string;
  instagramUrl?: string;
  youtubeUrl?: string;
  linkedInUrl?: string;
  tiktokUrl?: string;
  websiteTitle?: string;
  websiteTagline?: string;
  logoFile?: File;
  bannerFile?: File;
}

export interface UpdateOrganizationRequest {
  name?: string;
  slug?: string;
  organizationType?: OrganizationType;
  phone?: string;
  email?: string;
  description?: string;
  address?: string;
  city?: string;
  area?: string;
  latitude?: number;
  longitude?: number;
  googleMapsUrl?: string;
  isActive?: boolean;
  facebookUrl?: string;
  instagramUrl?: string;
  youtubeUrl?: string;
  linkedInUrl?: string;
  tiktokUrl?: string;
  websiteTitle?: string;
  websiteTagline?: string;
  logoFile?: File;
  bannerFile?: File;
}